import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Grid, List, Menu } from "lucide-react";
import "./Brand_product_page.css";
import SingleProductCard from "./Single_product_card";
import Top_Header from "./Top_Header";
import Header from "./Header";
import About_p from "./About_p";
import Footer from "./Footer";
import ImageSlider from './ImageSlider'
import StickyComponent from "./Sticky_component";
function BrandProductPage() {
  const brand = useParams().brandName;
  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [sortOption, setSortOption] = useState('default');
  const [priceFilter, setPriceFilter] = useState({ max: 1000 });
  const [priceRange, setPriceRange] = useState({ min: 0, max: 1000 });
  const [isOpenSidebar, setIsOpenSidebar] = useState(false);
  const [showMessage, setShowMessage] = useState(false);
  const [messageContent, setMessageContent] = useState('');
  const navigate = useNavigate();
  const catagoryList = ["Mobile & Tab",
    "Mobile Accessories",
    "Computer & Laptop",
    "Computer & Laptop Accessories",
    "TV & Home Entertainment",
    "Kitchen Appliances",
    "Home Appliances",
    "Refrigerators",
    "Audio",
    "Camera"];
  const itemsPerPage = 10; // Number of items per page

  const fetchProducts = async () => {
    try {
      // const response = await fetch('https://qixve8qntk.execute-api.ap-south-1.amazonaws.com/dev/excel-data', {
      //   method: 'POST',
      //   headers: {
      //     'Content-Type': 'application/json',
      //   },
      //   body: JSON.stringify({
      //     queryStringParameters: {
      //       "field": "Name",
      //       "value": brand
      //     }
      //   }),
      // });
      const response = await fetch(
        `https://ub3uejdxxh.execute-api.ap-south-1.amazonaws.com/dev/excel-data?field=Name&value=${brand}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({}),
        }
      )
      const data = await response.json();
      console.log("api data product brand page:", data);
      // const cleanedBody = data.body.replace(/NaN/g, 'null');
      // const parsedData = JSON.parse(cleanedBody);
      // console.log("Parsed data product brand page:", parsedData);
      if (response.ok) {
        return data;
      } else {
        return [];
      }

    } catch (error) {
      console.error('Error fetching products:', error);
    }
  };

  // const brandFromProduct = async () =>{
  //   try {
  //     const response = await fetch('https://qixve8qntk.execute-api.ap-south-1.amazonaws.com/dev/excel-data', {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json',
  //       },
  //       body: JSON.stringify({
  //         queryStringParameters: {
  //           "field": "Brands",
  //           "value": ""
  //         }
  //       }),
  //     });
  //     const data = await response.json();
  //     console.log("api data product Brands", data);
  //     const cleanedBody = data.body.replace(/NaN/g, 'null');
  //     const parsedData = JSON.parse(cleanedBody);
  //     console.log("Parsed data product Brands", parsedData);
  //     return parsedData;

  //   } catch (error) {
  //     console.error('Error fetching products:', error);
  //   }
  // }

  useEffect(() => {
    const fetchAndSetProducts = async () => {
      const products = await fetchProducts();
      // console.log("brand", brand);
      setProducts(products);
      setFilteredProducts(products);

      const prices = products.map((product) =>
        Number(product.Sale_price || product.Regular_price)
      );
      setPriceRange({ min: 0, max: Math.max(...prices) });
      setPriceFilter({ max: Math.max(...prices) });

    };

    fetchAndSetProducts();
  }, [brand]);

  const handleSortChange = (event) => {
    setSortOption(event.target.value);
  };
  const getSortedProducts = () => {
    let sorted = [...filteredProducts];

    if (sortOption === 'popularity') {
      sorted.sort((a, b) => (b.Popularity || 0) - (a.Popularity || 0));
    } else if (sortOption === 'price-low-to-high') {
      sorted.sort((a, b) => {
        const priceA = a?.Sale_price ? Number(a?.Sale_price) : Number(a?.Regular_price);
        const priceB = b?.Sale_price ? Number(b?.Sale_price) : Number(b?.Regular_price);
        return priceA - priceB;
      });
    } else if (sortOption === 'price-high-to-low') {
      sorted.sort((a, b) => {
        const priceA = a?.Sale_price ? Number(a?.Sale_price) : Number(a?.Regular_price);
        const priceB = b?.Sale_price ? Number(b?.Sale_price) : Number(b?.Regular_price);
        return priceB - priceA;
      });
    }

    return sorted;
  };

  const sortedProducts = getSortedProducts();

  // Pagination
  const paginatedProducts = sortedProducts.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );


  // Handlers for Next and Previous buttons
  const handleNextPage = () => {
    if (currentPage * itemsPerPage < filteredProducts.length) {
      setCurrentPage((prevPage) => prevPage + 1);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1);
    }
  };


  const applyFilters = () => {
    let filtered = [...products];

    // Apply price filter
    const { max } = priceFilter;
    filtered = filtered.filter((product) => {
      const price = Number(product.Sale_price || product.Regular_price);
      return price >= priceRange.min && price <= max;
    });

    setFilteredProducts(filtered);
    setCurrentPage(1); // Reset to the first page
  };

  // Handle Price Input Change
  const handlePriceChange = (event) => {
    setPriceFilter({ max: Number(event.target.value) });
  };

  return (

    <>
      <Top_Header />
      <Header />
      <ImageSlider></ImageSlider>

      {
        showMessage && <div className="brand-product-page-notification">
          <p>{messageContent}</p>
          <a href="/cart">| View Cart -{'>'}</a>
        </div>
      }
      <div>
        <div className="brand-product-page-container">
          <div className="brand-product-page-filter-container">
            <div className="brand-product-page-price-filter">
              <h5>Filter By Price</h5>
              <div className="price-slider-container">
                <input
                  type="range"
                  min={priceRange.min}
                  max={priceRange.max}
                  value={priceFilter.max}
                  onChange={handlePriceChange}
                  className="price-slider"
                />
                <div className="price-range-display">
                  <p>Price Range: ₹{priceRange.min} - ₹{priceFilter.max}</p>
                </div>
              </div>

              <button onClick={applyFilters}>Filter</button>
            </div>

            <div className="brand-product-page-brand-filter">
              <h5>Brands</h5>
            </div>

            <div className="brand-product-page-catagory-list">
              <h5>Categories</h5>
              {
                catagoryList.map((catagory, index) => (
                  <button key={index} onClick={() => navigate(`/category/${catagory}`)}>{catagory}</button>
                ))
              }
            </div>

          </div>
          <div className="brand-product-page-product-list-container">
            <h3>{brand.toUpperCase()}</h3>
            <div className="brand-product-page-sorting-container">
              <div>
                <Menu size={32} color="red" className="brand-product-page-menu-icon" onClick={() => setIsOpenSidebar(!isOpenSidebar)} />
                <Grid size={32} color="red" style={{ marginRight: "10%" }} />
                <List size={32} color="red" />
              </div>

              {/*for sorting */}
              <select value={sortOption} onChange={handleSortChange}>
                <option value='default'>Default</option>
                <option value='popularity'>Sort by Popularity</option>
                <option value='price-low-to-high'>Low to High</option>
                <option value='price-high-to-low'>High to Low</option>
              </select>
            </div>

            <div className="brand-product-page-product-list">
              {
                paginatedProducts?.length > 0 ?
                  paginatedProducts?.map((product, index) => (
                    <SingleProductCard key={index} product={product} setShowMessage={setShowMessage} setMessageContent={setMessageContent} />
                  ))
                  : <p>No products found</p>
              }
            </div>
          </div>
        </div>

        {/* Pagination controls */}
        <div className="pagination-container">
          <button
            onClick={handlePrevPage}
            disabled={currentPage === 1}
            className="pagination-btn"
          >
            Previous
          </button>
          <button
            onClick={handleNextPage}
            disabled={currentPage * itemsPerPage >= filteredProducts.length}
            className="pagination-btn"
          >
            Next
          </button>
        </div>
      </div>


      <About_p />
      <Footer />

      {
        isOpenSidebar && <div className="brand-product-page-side">
          <p onClick={() => setIsOpenSidebar(!isOpenSidebar)} className="brand-product-page-menu-close-icon">X</p>
          <div className="brand-product-page-filter-container-scroll">
            <div className="brand-product-page-filter-container" style={{ display: "flex", flexDirection: "column" }}>
              <div className="brand-product-page-price-filter">
                <h5>Filter By Price</h5>
                <div className="price-slider-container">
                  <input
                    type="range"
                    min={priceRange.min}
                    max={priceRange.max}
                    value={priceFilter.max}
                    onChange={handlePriceChange}
                    className="price-slider"
                  />
                  <div className="price-range-display">
                    <p>Price Range: ₹{priceRange.min} - ₹{priceFilter.max}</p>
                  </div>
                </div>

                <button onClick={applyFilters}>Filter</button>
              </div>

              <div className="brand-product-page-brand-filter">
                <h5>Brand</h5>

              </div>

              <div className="brand-product-page-catagory-list">
                <h5>Categories</h5>
                {
                  catagoryList.map((catagory, index) => (
                    <button key={index} onClick={() => navigate(`/category/${catagory}`)}>{catagory}</button>
                  ))
                }
              </div>

            </div>
          </div>
        </div>
      }

      <StickyComponent />
      {
        <img src='https://khoslaslider.s3.ap-south-1.amazonaws.com/image/Kosla-Mascot.png' className='khosla_da_img' onClick={() => window.open(
          'https://api.whatsapp.com/send/?phone=919674425425&text&type=phone_number&app_absent=0',
          '_blank'
        )} />
      }
    </>

  );
}

export default BrandProductPage;